export const HTTP_METHODS = {
	post_M: 'POST',
	get_M: 'GET',
};
